import { Button, Col, Input, message, Row, Typography, Result } from "antd";
import { FormItem } from "Components/form";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { ACTION_TYPES } from "Store/models/auth";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Yup from "ValidationModels/localizedYup";
import "Styles/app.less";
import { yupResolver } from "@hookform/resolvers";

const { Title, Text } = Typography;

const STATUS = {
  INPUT: 0,
  SENT: 1,
};

const FormValidation = Yup.object().shape({
  email: Yup.string().email().required(),
});

export default function ForgotPassoword(props) {
  const [status, setStatus] = useState(STATUS.INPUT);

  let history = useHistory();

  const { control, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(FormValidation),
  });

  const { forgotPassword } = useStoreActions((store) => store.auth);
  const { process } = useStoreState((store) => store.auth);

  useEffect(() => {
    if (process === ACTION_TYPES.SENT_PASSWORD_RESET_MAIL) {
      setStatus(STATUS.SENT);
    }
  }, [process]);

  const FormSubmit = async (form) => {
    forgotPassword({ email: form.email });
  };

  const passwordInputForm = (
    <div style={{ margin: 20 }}>
      <Row>
        <Col flex="1 1 100%" style={{ marginBottom: 32, textAlign: "center" }}>
          <Text type={"secondary"}>
            Şifrenizi sıfırlamak için, e-posta adresinize bir sıfırlama
            bağlantısı isteyin
          </Text>
        </Col>
        <Col flex="1 1 100%">
          <form onSubmit={handleSubmit(FormSubmit)}>
            <FormItem error={errors.email}>
              <Controller
                name="email"
                control={control}
                label="asdsa"
                as={<Input placeholder="E-Posta adresinizi girin" />}
              />
            </FormItem>

            <FormItem>
              <Button
                loading={process === ACTION_TYPES.SENDING_PASSWORD_RESET_MAIL}
                block
                type="primary"
                htmlType="submit"
              >
                Şifremi Sıfırla
              </Button>
            </FormItem>
          </form>
        </Col>
        <Col flex="1 1 100%" style={{ textAlign: "center" }}>
          Şifrenizi hatırladınız mı? <Link to="login">&nbsp;Giriş yapın</Link>
        </Col>
      </Row>
    </div>
  );

  const renderContent = () => {
    switch (status) {
      case STATUS.INPUT:
        return passwordInputForm;
      case STATUS.SENT:
        return (
          <div style={{ margin: 20 }}>
            <Col>
              <Result
                status="success"
                title="Sıfırlama bağlantısı e-postanıza gönderildi."
                subTitle="Gönderilen e-posta içerisindeki bağlantıya tıklayarak şifrenizi
              sıfırlayabilirsiniz."
                extra={[<Link to="login">Giriş</Link>]}
              />
            </Col>
          </div>
        );
    }
  };

  return (
    <div className={`forgot-password-form-wrapper `}>
      <Row className="forgot-password-form">{renderContent()}</Row>
    </div>
  );
}
